<spb-country-select
  [(model)]="this.input().country" [excluded]="excluded()"
/>

@if (this.input().country() !== 'SE') {
  <div>
    <spb-taxation-tin
      [(model)]="this.input().tin!"
    />
  </div>
}
